import { Logo } from './Logo';
import type { ReactNode } from 'react';

export function AppHeader({ title = 'Tattoo Try-On', subtitle, action, center }: { title?: string; subtitle?: string; action?: ReactNode; center?: ReactNode }) {
  return (
    <header className="app-header">
      <div className="app-header__brand"><Logo compact /><span className="app-header__copy"><strong>{title}</strong>{subtitle && <small>{subtitle}</small>}</span></div>
      {center && <div className="app-header__center">{center}</div>}
      {action && <div className="app-header__action">{action}</div>}
    </header>
  );
}
